import { useContext, useEffect, useRef, useState } from "react";
import {
  getOrganisationDetails,
  updateOrgDetails,
} from "../Dashboard/Services/DashboardServices";
import ImageCropperModal from "../../../Services/Comment/ImageCropperModal";
import { useFormik } from "formik";
import { uploadDoc } from "../../../Services/Global-Services/GlobalServices";
import { TostMsg } from "../../../App";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";
import { updateOrgAddressDetails } from "./Services/AdvanceSettingService";
import { Image } from "primereact/image";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { Dropdown } from "primereact/dropdown";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";

const AccountSetting = () => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [IsLoading, setIsloading] = useState(false);
  const [OrganizationDetails, setOrganizationDetails] = useState([]);
  const [acceptRatio, setAcceptRatio] = useState(0);
  const [showCropper, setShowCropper] = useState(false);
  const [organizationLogoSrc, setOrganizationLogoSrc] = useState(null);
  const [isImageloading, setIsImageloading] = useState(false);
  const toster = useContext(TostMsg);
  const [organizationImage, setOrganizationImage] = useState(null);
  const [employeelist, setEmployee] = useState([]);

  useEffect(() => {
    getOrganizationDetails();
    fetchEmployeeData();
  }, []);

  useEffect(() => {
    if (OrganizationDetails.length > 0) {
      OrganizationForm.setFieldValue(
        "OrgEmail",
        OrganizationDetails[0].OrgEmail || ""
      );
      OrganizationForm.setFieldValue(
        "OrgPhone",
        OrganizationDetails[0].OrgPhone || ""
      );
    }
  }, [OrganizationDetails]);

  async function getOrganizationDetails() {
    const params = {
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.Id,
    };

    try {
      setIsloading(true);
      const res = await getOrganisationDetails(params);
      setOrganizationDetails(res?.Data);

      setIsloading(false);
    } catch {
      setIsloading(false);
    }
  }

  const handleCloseBasicInfoModal = () => {
    document.querySelector("#edit-basic-info .btn-close")?.click();
  };

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setOrganizationLogoSrc(reader.result);
        setShowCropper(true);
        setAcceptRatio(1 / 1);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCropComplete = (croppedBlob) => {
    uploadOrganizationLogo([
      new File([croppedBlob], "cropped.jpg", { type: "image/jpeg" }),
    ]);
  };

  async function uploadOrganizationLogo(file) {
    setIsImageloading(true);
    if (file) {
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }

      let params = {
        UploadType: "OL",
        RefId: OrganizationDetails[0]?.Id,
      };
      try {
        const response = await uploadDoc(params, formData);
        const data = await response;
        const ImageURL = data?.Data;
        if (ImageURL) {
          setOrganizationImage(ImageURL[0]);

          userDetails.Organization.OrgLogo = ImageURL[0];
          localStorage.setItem("User", JSON.stringify(userDetails));
        }
        setIsImageloading(false);
      } catch (error) {
        setIsImageloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      } finally {
      }
    } else {
      setIsImageloading(false);
      toster.current.warn("No file selected");
    }
  }

  const OrganizationForm = useFormik({
    initialValues: {
      OrganizationName: "",
      OrgLogo: "",
      OrgEmail: "",
      OrgPhone: "",
      OrgOwnerId: "",
    },
    onSubmit: async (data) => {
      const body = {
        Id: OrganizationDetails[0]?.Id ? OrganizationDetails[0]?.Id : 0,
        OrgName: OrganizationForm.values.OrganizationName
          ? OrganizationForm.values.OrganizationName
          : OrganizationDetails[0]?.OrgName,
        OrgCode: OrganizationDetails[0]?.OrgCode
          ? OrganizationDetails[0]?.OrgCode
          : "",
        OrgEmail: OrganizationForm.values.OrgEmail
          ? OrganizationForm.values.OrgEmail
          : OrganizationDetails[0]?.OrgEmail,
        OrgPhone: OrganizationForm.values.OrgPhone
          ? OrganizationForm.values.OrgPhone
          : OrganizationDetails[0]?.OrgPhone,
        OrgLogo: organizationImage
          ? organizationImage
          : OrganizationDetails[0]?.OrgLogo,
        OrgOwnerId: OrganizationForm.values.OrgOwnerId
          ? OrganizationForm.values.OrgOwnerId
          : OrganizationDetails[0]?.OrgOwnerId,
        IsTemporary: 0,
      };
      try {
        const response = await updateOrgDetails(body);

        getOrganizationDetails();

        if (OrganizationForm.values.OrgOwnerId > 0) {
          document.querySelector("#edit-owner-name .btn-close")?.click();
        } else {
          document.querySelector("#edit-billing-contact .btn-close")?.click();
        }

        document.querySelector("#edit-org-name  .btn-close")?.click();
      } catch {}
    },
  });

  const setOrganizationDetail = () => {
    // if (value == 1) {
    OrganizationForm.setValues({
      OrganizationName: OrganizationDetails[0]?.OrgName,
      OrgLogo: OrganizationDetails[0]?.OrgLogo,
      OrgEmail: OrganizationDetails[0]?.OrgEmail,
      OrgPhone: OrganizationDetails[0]?.OrgPhone,
    });
  };

  const OrgAddressForm = useFormik({
    initialValues: {
      Address1: "",
      Address2: "",
      City: "",
      State: "",
      Country: "",
      Zip: "",
    },
    onSubmit: async (data) => {
      const body = {
        Id: OrganizationDetails[0]?.Id ? OrganizationDetails[0]?.Id : 0,

        GUID: OrganizationDetails[0]?.GUID ? OrganizationDetails[0]?.GUID : "",
        IsActive: true,
        CreatedDate: new Date().toISOString(),
        ModifiedDate: new Date().toISOString(),
        CreatedBy: 0,
        ModifiedBy: 0,
        OrgId: OrganizationDetails[0]?.OrgId
          ? OrganizationDetails[0]?.OrgId
          : 0,
        Address1: OrgAddressForm.values.Address1
          ? OrgAddressForm.values.Address1
          : OrganizationDetails[0]?.Address1,
        Address2: OrgAddressForm.values.Address2
          ? OrgAddressForm.values.Address2
          : OrganizationDetails[0]?.Address2,
        City: OrgAddressForm.values.City
          ? OrgAddressForm.values.City
          : OrganizationDetails[0]?.City,
        State: OrgAddressForm.values.State
          ? OrgAddressForm.values.State
          : OrganizationDetails[0]?.State,
        CountryId: 0,
        PINCODE: OrgAddressForm.values.Zip
          ? OrgAddressForm.values.Zip
          : OrganizationDetails[0]?.Zip,
        IsDefault: true,
      };
      try {
        const response = await updateOrgAddressDetails(body);
        getOrganizationDetails();
        document.querySelector("#edit-address .btn-close")?.click();
      } catch {}
    },
  });

  async function fetchEmployeeData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.Id,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 100000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      setIsloading(true);
      let employeesList = await getEmployeeList(params);
      setEmployee(employeesList?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  return (
    <div className="setting-detail-list">
      <div className="detail">
        <div className="title-text">
          <h3>Organization Details</h3>
        </div>
        <div className="main-top-details">
          <div className="acc-summary position-relative">
            <div className="inner-acc-summary">
              <strong className="owner-name">
                {OrganizationDetails[0]?.OrgName}
              </strong>
            </div>
            <div className="d-flex">
              <img
                src={
                  OrganizationDetails[0]?.OrgLogo ||
                  userDetails?.Organization?.OrgLogo
                }
                className="logo-abbr me-3"
              />
              <div className="setedit-position">
                <button
                  className="editactions"
                  title="Edit"
                  data-bs-toggle="modal"
                  data-bs-target="#edit-org-name"
                  onClick={setOrganizationDetail}
                >
                  <img
                    src="/images/tickets/edit-ico.svg"
                    className=""
                    title="Edit"
                  />
                </button>
              </div>
            </div>
          </div>

          <div className="acc-summary position-relative">
            <div className="d-flex justify-content-between">
              <div className="inner-acc-summary">
                <p className="m-0 accountown">Our OrgGenie Url</p>
              </div>
              <div className="fs-7 fw-lighter">
                http://devbox.bizbrolly.com:8883
              </div>
            </div>
          </div>
          <div className="acc-summary position-relative">
            <div className="inner-acc-summary">
              <p className="m-0 accountown">Organization Address</p>
            </div>
            <div className="col-12">
              <strong className="owner-name">
                <div className="d-flex align-items-center justify-content-end">
                  <div className="fs-7 fw-lighter me-3">
                    {OrganizationDetails[0]?.Address1 &&
                      OrganizationDetails[0]?.Address2 &&
                      OrganizationDetails[0]?.City &&
                      OrganizationDetails[0]?.State &&
                      OrganizationDetails[0]?.PINCode && (
                        <span>
                          {OrganizationDetails[0]?.Address1}{" "}
                          {OrganizationDetails[0]?.Address2},{" "}
                          {OrganizationDetails[0]?.City}{" "}
                          {OrganizationDetails[0]?.State}-
                          {OrganizationDetails[0]?.PINCode}
                        </span>
                      )}
                  </div>
                  <button
                    className="editactions "
                    title="Edit"
                    data-bs-toggle="modal"
                    data-bs-target="#edit-address"
                  >
                    <img
                      src="/images/tickets/edit-ico.svg"
                      className=""
                      title="Edit"
                    />
                  </button>
                </div>
              </strong>
            </div>
          </div>
          <div className="acc-summary position-relative">
            <div className="inner-acc-summary">
              <p className="m-0 accountown">Owner Name</p>
            </div>
            <div className="col-12">
              <strong className="owner-name">
                <div className="d-flex align-items-center">
                  {/* <img src="images/icon.png" className="logo-abbr me-3" /> */}
                  <img
                    src={OrganizationDetails[0]?.OwnerProfileImage}
                    className="logo-abbr me-3"
                  />
                  <div className="me-3">
                    {OrganizationDetails[0]?.OwnerName}(
                    {OrganizationDetails[0]?.OrgOwnerId})
                  </div>
                  <button
                    className="editactions "
                    title="Edit"
                    data-bs-toggle="modal"
                    data-bs-target="#edit-owner-name"
                    onClick={() => {
                      OrganizationForm.setFieldValue(
                        "OrgOwnerId",
                        OrganizationDetails[0].OrgOwnerId
                      );
                    }}
                  >
                    <img
                      src="/images/tickets/edit-ico.svg"
                      className=""
                      title="Edit"
                    />
                  </button>
                </div>
              </strong>
            </div>
          </div>
        </div>
      </div>
      <div className="gap"></div>
      <div className="accordion mt-4" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingTwo">
            {/* collapsed */}
            <button
              className="accordion-button "
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="true"
              aria-controls="collapseTwo"
            >
              Company Information
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse "
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body genral-accordian-body">
              <div className="row">
                <div className="col-lg-6">
                  <div className="inner general-setting-box">
                    <div className="genral-heading">
                      <h6>Primary Account Contact</h6>
                    </div>

                    <p>
                      {" "}
                      <span>Email:</span> {OrganizationDetails[0]?.OwnerEmail}{" "}
                    </p>
                    <p>
                      {" "}
                      <span>Contact:</span> {OrganizationDetails[0]?.OwnerPhone}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inner general-setting-box">
                    <div className="">
                      <div className="genral-heading">
                        <div className="d-flex justify-content-between align-items-center">
                          <h6>Billing Contact</h6>
                          <button
                            style={{ width: "24px" }}
                            className="editactions me-2"
                            title="Edit"
                            data-bs-toggle="modal"
                            data-bs-target="#edit-billing-contact"
                            onClick={setOrganizationDetail}
                          >
                            <img
                              src="/images/tickets/edit-ico.svg"
                              className=""
                              title="Edit"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                    <p>
                      <span>Email:</span> {OrganizationDetails[0]?.OrgEmail}
                    </p>
                    <p>
                      {" "}
                      <span>Contact:</span> {OrganizationDetails[0]?.OrgPhone}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="edit-org-name"
          className="modal fade custom-modal-area"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <form onSubmit={OrganizationForm.handleSubmit}>
              <div className="modal-content add-editexperience">
                <div className="modal-header">
                  <img
                    src="/images/org-img/leave/popup-backimg.png"
                    className="backimg"
                  />
                  <div className="img">
                    <img src="/images/popup-icons/featured-post.png" />
                  </div>
                  <button
                    onClick={handleCloseBasicInfoModal}
                    type="button"
                    className="btn-close m-auto"
                    data-bs-dismiss="modal"
                  ></button>
                </div>

                <div className="modal-body">
                  <h5 className="modal-title text-center">
                    Organization Information
                  </h5>
                  <div className="row gx-2 mt-4">
                    <div className="col-lg-6">
                      <label className="form-label">Company Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={OrganizationDetails[0]?.OrgName}
                      ></input>
                    </div>

                    <div className="col-lg-6">
                      {showCropper && organizationLogoSrc && (
                        <ImageCropperModal
                          image={organizationLogoSrc}
                          onCropComplete={handleCropComplete}
                          onClose={() => setShowCropper(false)}
                          acceptRatio={acceptRatio}
                        />
                      )}
                      <label className="form-label">Upload Logo</label>
                      {!showCropper && !organizationLogoSrc && (
                        <input
                          className="form-control"
                          type="file"
                          id="formFile"
                          accept="image/png, image/jpeg, image/jpg"
                          onChange={(event) => handleImageChange(event)}
                          value={organizationLogoSrc}
                        />
                      )}

                      {!showCropper && organizationImage && (
                        <a href={organizationImage} target="_blank">
                          <Image
                            src={organizationImage}
                            width={250}
                            preview={false}
                          />
                          {/* {organizationImage} */}
                        </a>
                      )}

                      {!showCropper &&
                        !organizationLogoSrc &&
                        OrganizationDetails[0]?.OrgLogo && (
                          <a
                            href={OrganizationDetails[0]?.OrgLogo}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Image
                              src={OrganizationDetails[0].OrgLogo}
                              width={250}
                              preview
                            />
                            {/* {OrganizationDetails[0]?.OrgLogo} */}
                          </a>
                        )}
                    </div>
                  </div>
                </div>
                <div className="modal-footer  justify-content-center mt-3">
                  <button
                    type="button"
                    className="cancelbtn-click"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="savebtn-click">
                    Update
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div
          id="edit-address"
          className="modal fade custom-modal-area"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <form onSubmit={OrgAddressForm.handleSubmit}>
              <div className="modal-content add-editexperience">
                <div className="modal-header">
                  <img
                    src="/images/org-img/leave/popup-backimg.png"
                    className="backimg"
                  />
                  <div className="img">
                    <img src="/images/popup-icons/featured-post.png" />
                  </div>
                  <button
                    onClick={handleCloseBasicInfoModal}
                    type="button"
                    className="btn-close m-auto"
                    data-bs-dismiss="modal"
                  ></button>
                </div>
                <div className="modal-body">
                  <h5 className="modal-title text-center">
                    Organization Address Information
                  </h5>
                  <div className="col-lg-12">
                    <div className="row gx-2 mt-4">
                      <div className="col-lg-6 mb-2">
                        <label className="form-label">Address1</label>
                        <input
                          type="text"
                          className="form-control"
                          value={OrgAddressForm.values.Address1}
                          onChange={(e) => {
                            OrgAddressForm.setFieldValue(
                              "Address1",
                              e.target.value
                            );
                          }}
                        ></input>
                      </div>
                      <div className="col-lg-6 mb-2">
                        <label className="form-label">Address 2</label>
                        <input
                          type="text"
                          className="form-control"
                          value={OrgAddressForm.values.Address2}
                          onChange={(e) => {
                            OrgAddressForm.setFieldValue(
                              "Address2",
                              e.target.value
                            );
                          }}
                        ></input>
                      </div>
                      <div className="col-lg-6 mb-2">
                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className="form-control"
                          value={OrgAddressForm.values.City}
                          onChange={(e) => {
                            OrgAddressForm.setFieldValue(
                              "City",
                              e.target.value
                            );
                          }}
                        ></input>
                      </div>
                      <div className="col-lg-6 mb-2">
                        <label className="form-label">State</label>
                        <input
                          type="text"
                          className="form-control"
                          value={OrgAddressForm.values.State}
                          onChange={(e) => {
                            OrgAddressForm.setFieldValue(
                              "State",
                              e.target.value
                            );
                          }}
                        ></input>
                      </div>
                      <div className="col-lg-6 mb-2">
                        <label className="form-label">Country</label>
                        <input
                          type="text"
                          className="form-control"
                          value={OrgAddressForm.values.Country}
                          onChange={(e) => {
                            OrgAddressForm.setFieldValue(
                              "Country",
                              e.target.value
                            );
                          }}
                        ></input>
                      </div>
                      <div className="col-lg-6 mb-2">
                        <label className="form-label">Zip</label>
                        <input
                          type="number"
                          className="form-control"
                          value={OrgAddressForm.values.Zip}
                          onChange={(e) => {
                            OrgAddressForm.setFieldValue("Zip", e.target.value);
                          }}
                        ></input>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer  justify-content-center mt-3">
                  <button
                    type="button"
                    className="cancelbtn-click"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="savebtn-click">
                    Update
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div
          id="edit-owner-name"
          className="modal fade custom-modal-area"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <form onSubmit={OrganizationForm.handleSubmit}>
              <div className="modal-content add-editexperience">
                <div className="modal-header">
                  <img
                    src="/images/org-img/leave/popup-backimg.png"
                    className="backimg"
                  />
                  <div className="img">
                    <img src="/images/popup-icons/featured-post.png" />
                  </div>
                  <button
                    onClick={handleCloseBasicInfoModal}
                    type="button"
                    className="btn-close m-auto"
                    data-bs-dismiss="modal"
                  ></button>
                </div>

                <div className="modal-body">
                  <h5 className="modal-title text-center">
                    Account Owner Information
                  </h5>
                  <div className="row gx-2 mt-4">
                    <div className="col-lg-12">
                      <label className="form-label">Owner Name</label>

                      <Dropdown
                        className="form-control"
                        options={employeelist}
                        optionLabel="FullName"
                        optionValue="EmpId"
                        placeholder="Select Employee"
                        checkmark={true}
                        highlightOnSelect={false}
                        value={OrganizationForm.values.OrgOwnerId}
                        onChange={(e) => {
                          OrganizationForm.setFieldValue("OrgOwnerId", e.value);
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="modal-footer  justify-content-center mt-3">
                  <button
                    type="button"
                    className="cancelbtn-click"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="savebtn-click">
                    Update
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div
          id="edit-billing-contact"
          className="modal fade custom-modal-area"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <form onSubmit={OrganizationForm.handleSubmit}>
              <div className="modal-content add-editexperience">
                <div className="modal-header">
                  <img
                    src="/images/org-img/leave/popup-backimg.png"
                    className="backimg"
                  />
                  <div className="img">
                    <img src="/images/popup-icons/featured-post.png" />
                  </div>
                  <button
                    onClick={handleCloseBasicInfoModal}
                    type="button"
                    className="btn-close m-auto"
                    data-bs-dismiss="modal"
                  ></button>
                </div>
                <div className="modal-body">
                  <h5 className="modal-title text-center">Biiling Contact</h5>
                  <div className="row gx-2 mt-4">
                    <div className="col-lg-6">
                      <label className="form-label">Email</label>
                      <input
                        type="text"
                        className="form-control"
                        name="OrgEmail"
                        value={OrganizationForm.values.OrgEmail}
                        onChange={(e) => {
                          OrganizationForm.setFieldValue(
                            "OrgEmail",
                            e.target.value
                          );
                        }}
                      ></input>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Contact No.</label>
                      <input
                        type="text"
                        className="form-control"
                        name="OrgPhone"
                        minLength={10}
                        maxLength={10}
                        value={OrganizationForm.values.OrgPhone}
                        onChange={(e) => {
                          OrganizationForm.setFieldValue(
                            "OrgPhone",
                            e.target.value
                          );
                        }}
                      />
                      {OrganizationForm.values.OrgPhone?.length < 10 && (
                        <div class="invalid-feedback">
                          Contact No. should be minimum length of 10.
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="modal-footer  justify-content-center mt-3">
                    <button
                      type="button"
                      className="cancelbtn-click"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button type="submit" className="savebtn-click">
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSetting;
